import ConfirmNotification, { CONFIRM_NOTIFICATION_THEME } from "../Notifications/ConfirmNotification";
import PlanUpdateEstimationModal from "../Profile/PlanUpdateEstimationModal";

let confirmNotification = new ConfirmNotification({})

const showConfirmNotification = (configs) => {
  confirmNotification.confirmMode = true;
  confirmNotification.instanceSettings = {
    ...confirmNotification.defaults,
    ...configs,
    modalTheme: CONFIRM_NOTIFICATION_THEME.LIGHT,
  }

  confirmNotification.createDialog(confirmNotification.instanceSettings)
}

class GetPlanModal {
  constructor() {
    this.subscriptionPlan = window.subscriptionPlan ?? {};
    this.stripePlans = window.stripePlans ?? {};
    this.render();

    this.planUpdateEstimationModal = new PlanUpdateEstimationModal();
  }

  render() {
    this.$modal = $('#plan-comparison-modal');

    window.openGetPlansModal = () => {
      this.$modal.addClass('is-active');
    }
    ///open on click on #get-plan
    $('#get-plan').on('click', () => {
      this.$modal.addClass('is-active');
    });
    ///close on click on #get-plan-modal-close
    $('#get-plan-modal-close').on('click', () => {
      this.$modal.removeClass('is-active');
    });

    const $this = this;
    this.$modal.find('.subscription-upgrade-btn').on("click", function (e) {
      e.preventDefault();

      const planCode = $(this).data('plan-code');
      const interval = $(this).data('interval');

      $this.planUpdateEstimationModal.show(planCode, interval, 'upgrade');
    });
    this.$modal.find('.subscription-downgrade-btn').on("click", function (e) {
      e.preventDefault();

      const planCode = $(this).data('plan-code');
      const interval = $(this).data('interval');

      $this.planUpdateEstimationModal.show(planCode, interval, 'downgrade');
    });
  }
}

export default GetPlanModal;
